import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../../components/Layout";
import PageIntro from "../../components/PageIntro";
import ImageBanner from "../../components/ImageBanner";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import "../../styles/brand.css";
import IndustriesGrid from "./IndustriesGrid";
import IndustriesApproach from "./IndustriesApproach";
import {
  finalCtaContent,
  heroContent,
  industries,
  industriesSeo,
} from "./industriesContent";

const SITE_URL = "https://mbasolutions.co";
const CANONICAL = `${SITE_URL}${industriesSeo.slug}`;

const buildJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: heroContent.h1,
    description: industriesSeo.description,
    url: CANONICAL,
    mainEntity: {
      "@type": "ItemList",
      itemListElement: industries.map((industry, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: industry.title,
      })),
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      {
        "@type": "ListItem",
        position: 2,
        name: heroContent.h1,
        item: CANONICAL,
      },
    ],
  },
];

/* A link like /industries-we-serve#textile-garments (the Home page's industry
   cards) lands on that industry's card once the page has rendered. */
const useScrollToHash = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
    return () => clearTimeout(t);
  }, [hash]);
};

const IndustriesWeServe = () => {
  useScrollToHash();
  return (
  <Layout
    title={industriesSeo.title}
    description={industriesSeo.description}
    keywords="industries we serve, ISO certification by industry, food safety certification, textile compliance, manufacturing ISO, IT ISO 27001, export compliance, supply chain certification, MBA Solutions"
    canonical={CANONICAL}
    jsonLd={buildJsonLd()}
  >
    <main className="industries-page brand-page bg-white">
      <ImageBanner
        src="/assets/banners/Industries-We-Serve.jpeg"
        alt="Industries We Serve — MBA Solutions"
        width={1832}
        height={560}
        whole
      />
      <PageIntro
        id="industries-hero-heading"
        title={heroContent.h1}
        subtitle={heroContent.subtitle}
        paragraphs={heroContent.paragraphs}
      />
      <IndustriesGrid />
      <IndustriesApproach />
      <FinalCtaPanel
        id="industries-final-cta-heading"
        title={finalCtaContent.title}
        paragraph={finalCtaContent.paragraph}
        cta={finalCtaContent.cta}
        image="/assets/cta/certification-journey.webp"
      />
    </main>
  </Layout>
  );
};

export default IndustriesWeServe;
